import { ReactKit } from '@team/react';
import { Layout } from './components/layout';
import { Button, Link } from './components/item';

export const Tabbar = ReactKit.createCompoundComponent(Layout, {
  Item: Button,
  Link,
});

Tabbar.displayName = 'Tabbar';
Tabbar.Item.displayName = 'TabbarItemButton';
Tabbar.Link.displayName = 'TabbarItemLink';
